const frTranslation = {
  NewUser: 'Nouvel utilisateur',
  UserList: "liste  d'utilisateur",
};

export default frTranslation;
